<script lang="ts">
    import { t } from "@lernetz/svelte-translate";
    import ClassMode from "./ClassMode.svelte";
    import SingleMode from "./SingleMode.svelte";
    import { Icon } from "@lernetz/svelte-icon";
    import { setupSharedProps, sharedProps } from "../../setup";

    export let onClose: () => void;
    export let dashboard;
    export let type;

    let showClassMode = false;
    let showSingleMode = false;

    setupSharedProps();

    if(type == "prior") {
        if(dashboard.priorMode == "class") {
            openClassMode()
        }
        else if(dashboard.priorMode == "single") {
            openSingleMode()
        }
    }
    else if(type == "after") {
        if(dashboard.afterMode == "class") {
            openClassMode()
        }
        else if(dashboard.afterMode == "single") {
            openSingleMode()
        }
    }

    function openClassMode() {
        showClassMode = true;
    }

    function closeClassMode() {
        showClassMode = false;
        if(type == "prior") {
            if(dashboard.priorMode == "class") {
                onClose();
            }
        }
        else if(type == "after") {
            if(dashboard.afterMode == "class") {
                onClose();
            }
        }
    }

    function openSingleMode() {
        showSingleMode = true;
    }

    function closeSingleMode() {
        showSingleMode = false;
        if(type == "prior") {
            if(dashboard.priorMode == "single") {
                onClose();
            }
        }
        else if(type == "after") {
            if(dashboard.afterMode == "single") {
                onClose();
            }
        }
    }

</script>

<div class="w-full h-full fixed {dashboard.cycle == 'cycle1' ? 'bg-yellow-light' : 'bg-green-light'} flex flex-col items-center z-10 overflow-y-auto p-16 md:p-24 xl:p-40">
    {#if showClassMode}
      <ClassMode onClose="{closeClassMode}" {dashboard} {type}></ClassMode>
    {/if}
    {#if showSingleMode}
      <SingleMode onClose="{closeSingleMode}" {dashboard} {type}></SingleMode>
    {/if}
    <div class="w-full flex justify-between items-start max-w-1280 gap-12">
        <button on:click="{onClose}" class="w-48 h-48 bg-blue-main text-white rounded-md z-10 shrink-0">
            <Icon name="arrow-circle-left" class="w-28 h-28 place-self-center"></Icon>
        </button>
        <div class="text-28 md:text-40 font-bold font-Caveat text-blue-main text-center">
            {$t('choose mode')}
        </div>
        <Icon name="{sharedProps.currentLocale == 'de' ? 'logo-element-hero' : 'logo-element-hero-fr'}" class="w-96 md:w-128 xl:w-160 shrink-0 -mt-24 md:-mt-48"></Icon>
    </div>
    <div class="text-18 mt-24 md:mt-32 text-center">
        {$t('Select which of the two modes you would like to use for the knowledge query.')}
    </div>
    <div class="mt-24 md:mt-32 text-white flex flex-col md:flex-row gap-16 md:gap-24 w-full max-w-1280">
        <div class="bg-blue-main p-24 md:p-32 rounded-3xl md:min-h-[333px] flex flex-col flex-1">
            <div class="text-28 font-bold text-center">{$t('in class')}</div>
            <ul class="list-disc list-inside space-y-2 mt-24">
                <li>{$t('Conducting the knowledge check with the whole class')}</li>
                <li>{$t('Projector/whiteboard')}</li>
                <li>{$t('Teacher guides the class through the questions')}</li>
            </ul>
            <div class="text-center mt-32 md:mt-auto flex justify-center">
                <button class="text-white bg-yellow-extra hover:bg-yellow-main rounded-lg px-16 py-8 flex gap-12" on:click="{openClassMode}">{$t('choose')}
                    <Icon name="arrow-right" class="w-28 h-28 place-self-center"></Icon>
                </button>
            </div>
        </div>
        <div class="bg-blue-main p-24 md:p-32 rounded-3xl md:min-h-[333px] flex flex-col flex-1">
            <div class="text-28 font-bold text-center">{$t('single')}</div>
            <ul class="list-disc list-inside space-y-2 mt-24">
                <li>{$t('Conducting knowledge tests individually or in groups')}</li>
                <li>{$t('Laptop/tablet or smartphone')}</li>
                <li>{$t('Individual development')}</li>
            </ul>
            <div class="text-center mt-32 md:mt-auto flex justify-center">
                <button class="text-white bg-yellow-extra hover:bg-yellow-main rounded-lg px-16 py-8 flex gap-12" on:click="{openSingleMode}">{$t('choose')}
                    <Icon name="arrow-right" class="w-28 h-28 place-self-center"></Icon>
                </button>
            </div>
        </div>
    </div>
</div>
